
import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../../StateManagement/actions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";

import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { useNavigate } from "react-router-dom";
import { labelStore } from "../../../FrontEnd/UpdateChange/LableStore";
import Inventory2Icon from '@mui/icons-material/Inventory2';

export const ItemMasterList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();

  const [selectedId, setSelectedId] = useState<string | number>(0);
  const [isPopupOpen, setPopupOpen] = useState(false);

  useEffect(() => {
    updateMainHeader("Inventory");
    labelStore.updateIcon(<Inventory2Icon sx={{ fontSize: 32 }} />);
  }, []);


  const source = {
    url: "items/list",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
    type: 'GET' as const
  };


  breadCrumbsStore.updateBreadCrumbs([
    { 'Sale List': '/sale/list' },
  ]);


  const columns: IColumns[] = [
    {
      header: "Item Code",
      fieldName: "ItemCode",

    },

    {
      header: "Item Name",
      fieldName: "ItemName",

    },

    {
      header: "Category",
      fieldName: "CategoryName",
      tooltip: true,
      //   sortable: true,
    },

    {
      header: "Model NO",
      fieldName: "ModelNo",
    },

    {
      header: "Supplier Name",
      fieldName: "SupplierName",

      //   sortable: true,
    },
    {
      header: "Purchase Price",
      fieldName: "PurchasePrice",
      type: "amount"

    },
    {
      header: "Selling Price",
      fieldName: "SellingPrice",
      type: "amount"

    },
    {
      header: "Stock",
      fieldName: "MinStock",

    },


    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: (action: string, row: any) => {


        const itemId = row.ItemId;
        if (!itemId) {
          console.error("❌ No valid ID found in row:", row);
          showMessage("Invalid warehouse data - missing ID", "error");
          return;
        }

        if (action === "Edit") {
          navigate(`/itemmaster/${itemId}`);
        } else if (action === "Delete") {
          setSelectedId(itemId);
          setPopupOpen(true);
        }
      },
    },
  ];

  const handleClick = () => {
    navigate("/itemmaster");
  };

  return (
    <Grid p={3}>
      <Grid container spacing={2}>

        <Grid item xs={12}>
          <WSDataGrid
            id="itemGrid"
            title="Item Master"
            headerType="modern"
            columns={columns}
            source={source}
            rowsPerPageCount={10}
            searchBox={{ searchMode: "query" }}
            addButton={{ label: "Add New Item", color: "secondary" }}
            onAddButtonClick={handleClick}

            // onSelectionChange={handleBulkSelection}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
            exportCsv
            importCsv
            importCsvEndpoint="items/upload-excel"
          />
        </Grid>

        <ConfirmationPopup
          type="DELETE"
          apiUrl="items"
          id={selectedId}
          confirmMessage="Are you sure you want to delete this sale invoice?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={(data: any) => {
            dispatch(resetDataComponent("itemGrid"));
            if (data.success === true) {
              showMessage(data?.message, "success");
            } else {
              showMessage(data?.detail, "error");
            }
          }}
        />
      </Grid>
    </Grid>
  );
});

